import type { BaseObject } from './types.js'
import type { OrgRole } from './OrganizationMembership.js'

export enum OrgInvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED'
}

export type InviteUsersToOrganizationUserInput = {
  email: string
  name?: string
}

export type InviteUsersToOrganizationRequest = {
  organizationId: string
  role: OrgRole
  users: InviteUsersToOrganizationUserInput[]
}

export type InviteUsersToOrganizationResult = {
  /** `acceptUrl` is present ONLY on the dev project for AI-agent test emails (ai-agentic-testing). */
  invitedUsers: Array<{ email: string; inviteId: string; acceptUrl?: string }>
  failedUsers: Array<{ email: string; error: string }>
}

/**
 * Stored under `organization_invites` collection.
 *
 * `emailSent` / `emailSentAt` track whether a BO admin has clicked "Send invite email"
 * for onboarding-style invites (created without auto-sending). For invites created via
 * `inviteUserToOrganization` / `inviteUsersToOrganization` the email is sent on create
 * and these fields are not populated.
 */
export type OrgInvitation = BaseObject & {
  organizationId: string
  email: string
  role: OrgRole
  status: OrgInvitationStatus
  invitedByUserId: string
  /** SHA-256 hex hash of the raw invite token. Raw token is never stored — it appears only in the emailed accept URL. */
  inviteTokenHash: string
  expiresAt: string
  acceptedAt?: string
  acceptedByUserId?: string
  /** True once the onboarding invite email has been sent (manual send from BO). */
  emailSent?: boolean
  /** ISO timestamp of the most recent successful onboarding invite email send. */
  emailSentAt?: string
}
